import { IPayLoadGetList } from "app/common/interface"

export enum ELockPeriodType {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}
export enum ELockModuleType {
  DAILY_INVOICE = 'daily_invoice',
}

export interface ISyncLock {
  module: ELockModuleType // 🔥 new: distinguish lock by module
  periodType: ELockPeriodType // month, day, week, year
  date: Date // the date representing the period to be locked/unlocked
  isLocked: boolean // true if explicitly unlocked
}

export interface IFilterGetSyncLock extends IPayLoadGetList {
  startDate?: string
  endDate?: string
  module: ELockModuleType // 🔥 new: distinguish lock by module
  periodType: ELockPeriodType // month, day, week, year
}
